var data = {
	"body": "<g fill=\"none\"><path d=\"M9 14a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H9z\" fill=\"currentColor\"/><path d=\"M7 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7zM6 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4z\" fill=\"currentColor\"/></g>",
	"width": 20,
	"height": 20
};
export default data;
